export enum DomainType {
  Birthplace = 3,
  Municipality = 2,
  Deathplace = 5,
  DeathAutority = 6,
  ReligiousCults = 8,
  MinisterReligion = 9,
  Statistic = 11,
  Archive = 23,
  RegistryOffice = 26,
  Scope = 30,
  EmergencyRegister = 31,
  Communication = 93,
  CommunicationType = 66,
}
